import { getSearchParams } from '@/js/modules/updateUrls';
import { EventBus } from '@global-js/event-bus';
import {
	computed, onMounted, onUnmounted, ref,
} from 'vue';

/**
 * A composable that returns the search params from the URL
 * @param questionMark	Parameter to add a question mark to the beginning of the string
 * @returns 
 */
export const useSearchParams = (questionMark: boolean = false ) => {
	const searchParams = ref<string>(getSearchParams());

	const updateParams = () => {
		searchParams.value = getSearchParams();
	};
	onMounted(() => {
		EventBus.$on('url:change', updateParams);
	});
	onUnmounted(() => {
		EventBus.$off('url:change', updateParams);
	});
	return computed(() => decodeURIComponent(`${questionMark ? '?' : ''}` + searchParams.value));
};
